import { api } from '../../DefaultService';
import { IMoniCreateProps, IMoniProps, IMoniUpdateParams } from './types';

const ENDPOINT = '/v1/integrations/moni';

export const createMoniIntegrationAsync = async (data: IMoniCreateProps) => {
  return await api
    .post(`${ENDPOINT}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllMoniIntegrationsAsync = async (): Promise<IMoniProps[]> => {
  return await api
    .get<IMoniProps[]>(`${ENDPOINT}/getAllByLicense`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getMoniIntegrationByIdAsync = async (
  id: number,
): Promise<IMoniProps> => {
  return await api
    .get<IMoniProps>(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateMoniIntegrationAsync = async ({
  id,
  data,
}: IMoniUpdateParams) => {
  return await api
    .put(`${ENDPOINT}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteMoniIntegrationAsync = async (id: number) => {
  return await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};
